import { render, staticRenderFns } from "./Optimizer.vue?vue&type=template&id=a4a8e702&"
import script from "./Optimizer.vue?vue&type=script&lang=js&"
export * from "./Optimizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports